<template>
    <v-autocomplete
        v-if="!ethnicityIsLegacy()"
        item-text="value"
        item-value="valueid"
        :items="ethnicityItems()"
        :value="internalValue"
        @input="handleInput"
    />

    <div v-else>
        <v-dialog v-model="migrateDialogShown" max-width="400px">
            <v-card>
                <v-card-title>
                    Migrate ethnicity code
                </v-card-title>
                <v-card-text>
                    This ethnicity is specified using a legacy code.
                    Editing it will migrate it to the current code set - however, you will need to specify the new code manually;
                    the new code will not be automatically selected from the dropdown.
                    <br><br>
                    Would you like to continue?
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="migrateDialogShown = false; resetEthnicity()">Yes</v-btn>
                    <v-btn @click="migrateDialogShown = false">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-tooltip>
        
        </v-tooltip>
        <v-text-field
            readonly
            :value="ethnicityLabel() + ' (legacy code #' + String(value) + ')'"
            @click="migrateDialogShown = true"
        />
    </div>
</template>

<script>

export default {
    'data' : function() {
        return {
            'migrateDialogShown' : false,
            'internalValue' : this.value
        };
    },
    'methods' : {
        'ethnicityIsLegacy' : function(v) {
            if(typeof v == 'undefined') {
                v = this.internalValue;
            }
            return !/^[0-9][0-9][0-9]$/.test(String(v)) && v != 0 && v != null;
        },
        'ethnicityItems' : function(includeLegacy) {
            var self = this;
            includeLegacy = (typeof includeLegacy == 'undefined' ? false : true);
            return this.$store.getters.lookup('Ethnicity').filter(function(d) {
                return !self.ethnicityIsLegacy(d.valueid) || includeLegacy;
            });
        },
        'ethnicityLabel' : function() {
            const items = this.ethnicityItems(true);

            for(const x of items) {
                if(x.valueid == this.value) {
                    return x.value;
                }
            }

            return 'Ethnicity code unknown';
        },
        'resetEthnicity' : function() {
            this.internalValue = 944;
            this.$emit('input', 944);
        },
        'handleInput' : function(e) {
            this.$emit('input', e);
        }
    },
    'props' : {
        'value' : Number
    }
};

</script>